import { MutationTree } from 'vuex'
import { UIState } from './types'
import store from '@/store'
import Vue from 'vue'

export const mutations: MutationTree<UIState> = {
  setDrawerComponent(state, payload) {
    state.drawerComponent = payload
  },
  closeDrawer: state => {
    state.drawer = false
    state.drawerComponent = ''
  },
  initMapUIState(state) {
    const userId = localStorage.getItem('user_id')
    if (
      JSON.parse(String(localStorage.getItem(`showMarkerCluster_${userId}`)))
    ) {
      state.showCluster = JSON.parse(
        String(localStorage.getItem(`showMarkerCluster_${userId}`))
      )
    }
    if (JSON.parse(String(localStorage.getItem(`showEntityName_${userId}`)))) {
      state.showEntityName = JSON.parse(
        String(localStorage.getItem(`showEntityName_${userId}`))
      )
    }
    if (JSON.parse(String(localStorage.getItem(`showEntityType_${userId}`)))) {
      state.showEntityType = JSON.parse(
        String(localStorage.getItem(`showEntityType_${userId}`))
      )
    }
  },
  setAmountOfThing(state, amountOfThing) {
    state.amountOfThings = amountOfThing
  },
  setMainGridLoading(state, { establishLoading, upgradeLocalDBTagsLoading, loadingThingsSubscription }) {
    if (typeof establishLoading !== 'undefined')
      state.mainGridLoading.establishLoading = establishLoading
    if (typeof upgradeLocalDBTagsLoading !== 'undefined')
      state.mainGridLoading.upgradeLocalDBTagsLoading = upgradeLocalDBTagsLoading
    if (typeof loadingThingsSubscription !== 'undefined')
      state.mainGridLoading.loadingThingsSubscription = loadingThingsSubscription
  },
  toggleDrawer: state => (state.drawer = !state.drawer),
  toggleCluster(state) {
    state.showCluster = !state.showCluster
  },
  toggleEntityType(state) {
    state.showEntityType = !state.showEntityType
  },
  toggleEntityName(state) {
    state.showEntityName = !state.showEntityName
  },
  toggleClusterCreated(state, payload) {
    state.clusterCreated = payload
  },
  toggleFollow(state) {
    state.follow = !state.follow
  },
  toggleThingInfo(state) {
    state.showThingInfo = !state.showThingInfo
  },
  openSnackBar(state, { msg, snackBarButtonClose = true }) {
    state.snackBarText = msg
    state.showSnackBar = true
    state.snackBarButtonClose = snackBarButtonClose
  },
  closeSnackBar(state, msge) {
    state.snackBarText = ''
    state.showSnackBar = false
  },
  openTrailView(state) {
    state.trailView = true
  },
  closeTrailView(state) {
    state.trailView = false
  },
  openTemperatureByTimeView(state) {
    state.temperatureByTimeView = true
  },
  closeTemperatureByTimeView(state) {
    state.temperatureByTimeView = false
  },
  setThingInfo(state, thing) {
    Vue.set(state, 'thingInfo', thing)
  },
  openThingInfo(state, thing) {
    Vue.set(state, 'thingInfo', thing)
    //para evitar setear en true el state cada vez que se hace un click en el marker
    if (!state.showThingInfo) state.showThingInfo = true
  },
  closeThingInfo(state) {
    state.showThingInfo = false
    state.thingInfo = {}
  },
  closeLabelSelected(state) {
    if (state.thingInfo.hasOwnProperty('id'))
      store.dispatch('mapState/resetMarker', state.thingInfo)
  },
  setFollowTimerIsActive(state, value) {
    state.followTimerIsActive = value
  },
  toggleLayoutMovileLiveTracking(state, value) {
    state.selectionItemInDetail = value
  }
}
